const answerSheetContentType = {
  HEADER_IMG: 1,
  QUESTION_IMG: 2,
  ANSWER_IMG: 3,
  AUDIO_HTML: 4,
} as const
type AnswerSheetContentType = typeof answerSheetContentType[keyof typeof answerSheetContentType]

const answerViewPhase = {
  OTHER: 0,
  KOKUGO_ANSWER: 1,
  KOKUGO_SUBMIT: 2,
} as const
type AnswerViewPhase = typeof answerViewPhase[keyof typeof answerViewPhase]

/**
 * 1: 縦型配置（国語以外の配置、上から下へ配置）
 * 2: 横型配置（国語解答ページの配置、右から左へ配置）
 * 3: 集約配置（国語提出画像の配置、日本語の縦書き順序(Right to Left)の配置）
 */
const layoutPattern = {
  VERTICAL_UP_TO_DOWN: 1,
  HORIZONTAL_RIGHT_TO_LEFT: 2,
  AGGREGATE_RIGHT_TO_LEFT: 3,
} as const
type LayoutPattern = typeof layoutPattern[keyof typeof layoutPattern]

/**
 * 正整数の場合は、画像の配置順序を示す
 * -1, 0 は特殊ケースであり、下記の通り
 *
 * -1: 音声再生エリア
 * 0: 問題用紙エリア
 */
type PositionNumber = number

type ModalEvent = 'SUSPEND_STUDY' | 'CLEAR_ALL' | 'SAVE' | 'BLANK' | 'ERROR_NOTIFICATION'
type ActiveModalObject = {
  [key in ModalEvent]: boolean
}

const suspendStudyModalTexts = {
  message:
    '<ruby>解<rp>(</rp><rt>かい</rt><rp>)</rp></ruby><ruby>答<rp>(</rp><rt>とう</rt><rp>)</rp></ruby>をほぞんして、<ruby>学<rp>(</rp><rt>がく</rt><rp>)</rp></ruby><ruby>習<rp>(</rp><rt>しゅう</rt><rp>)</rp></ruby>をやめるよ。',
  whiteText:
    '<ruby>学<rp>(</rp><rt>がく</rt><rp>)</rp></ruby><ruby>習<rp>(</rp><rt>しゅう</rt><rp>)</rp></ruby>にもどる',
  blueText:
    '<ruby>学<rp>(</rp><rt>がく</rt><rp>)</rp></ruby><ruby>習<rp>(</rp><rt>しゅう</rt><rp>)</rp></ruby>をやめる',
}
const clearAllModalTexts = {
  message:
    '「黒」でかいたものが<ruby><rb>全</rb><rp>（</rp><rt>ぜん</rt><rp>）</rp><rb>部</rb><rp>（</rp><rt>ぶ</rt><rp>）</rp></ruby><ruby><rb>消</rb><rp>（</rp><rt>き</rt><rp>）</rp></ruby>えてしまうよ。<br />よかったら「<ruby><rb>全</rb><rp>（</rp><rt>ぜん</rt><rp>）</rp><rb>部</rb><rp>（</rp><rt>ぶ</rt><rp>）</rp></ruby><ruby><rb>消</rb><rp>（</rp><rt>け</rt><rp>）</rp></ruby>す」をタップしてね。',
  whiteText: '<ruby>消<rp>(</rp><rt>け</rt><rp>)</rp></ruby>さない',
  blueText:
    '<ruby>全<rp>(</rp><rt>ぜん</rt><rp>)</rp></ruby><ruby>部<rp>(</rp><rt>ぶ</rt><rp>)</rp></ruby><ruby>消<rp>(</rp><rt>け</rt><rp>)</rp></ruby>す',
}
const saveModalTexts = {
  message:
    '<ruby>解<rp>(</rp><rt>かい</rt><rp>)</rp></ruby><ruby>答<rp>(</rp><rt>とう</rt><rp>)</rp></ruby>をほぞんしたよ。',
  whiteText: 'わかった',
}
const blankErrorTexts = {
  message:
    '【エラー】<br>白紙では<ruby>提<rp>(</rp><rt>てい</rt><rp>)</rp></ruby><ruby>出<rp>(</rp><rt>しゅつ</rt><rp>)</rp></ruby>できません。<ruby>問<rp>(</rp><rt>もん</rt><rp>)</rp></ruby><ruby>題<rp>(</rp><rt>だい</rt><rp>)</rp></ruby>に<ruby>取<rp>(</rp><rt>と</rt><rp>)</rp></ruby>り組んでから、「ていしゅつにすすむ」をおしてください。<br>※おもて・うらがある場合は、<ruby>両<rp>(</rp><rt>りょう</rt><rp>)</rp></ruby><ruby>面<rp>(</rp><rt>めん</rt><rp>)</rp></ruby>に<ruby>取<rp>(</rp><rt>と</rt><rp>)</rp></ruby>り組んでください。<br>※<ruby>両<rp>(</rp><rt>りょう</rt><rp>)</rp></ruby><ruby>面<rp>(</rp><rt>めん</rt><rp>)</rp></ruby>に書きこみがあっても<ruby>提<rp>(</rp><rt>てい</rt><rp>)</rp></ruby><ruby>出<rp>(</rp><rt>しゅつ</rt><rp>)</rp></ruby>ができない場合は、「おもて・うらをきりかえる」をおしたうえで、<ruby>提<rp>(</rp><rt>てい</rt><rp>)</rp></ruby><ruby>出<rp>(</rp><rt>しゅつ</rt><rp>)</rp></ruby>してください。',
  whiteText: 'わかった',
}
const errorUserMessage =
  'エラーが<ruby>発生<rt>はっせい</rt></ruby>しました。<ruby>再度<rt>さいど</rt></ruby>お<ruby>試<rt>ため</rt></ruby>しください。'

export {
  answerSheetContentType,
  AnswerSheetContentType,
  answerViewPhase,
  AnswerViewPhase,
  layoutPattern,
  LayoutPattern,
  PositionNumber,
  ModalEvent,
  ActiveModalObject,
  suspendStudyModalTexts,
  clearAllModalTexts,
  saveModalTexts,
  blankErrorTexts,
  errorUserMessage,
}
